import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Admin.css';

const Admin = () => {
  const [authenticated, setAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  
  // 管理数据
  const [profile, setProfile] = useState('');
  const [videos, setVideos] = useState([]);
  const [downloads, setDownloads] = useState([]);
  const [aiLauncherResources, setAiLauncherResources] = useState([]);
  const [qqGroups, setQqGroups] = useState([]);
  const [carouselItems, setCarouselItems] = useState([]);
  const [openSourceProjects, setOpenSourceProjects] = useState([]);
  
  // 编辑状态
  const [editingVideo, setEditingVideo] = useState(null);
  const [editingDownload, setEditingDownload] = useState(null);
  const [editingAiLauncherResource, setEditingAiLauncherResource] = useState(null);
  const [editingQqGroup, setEditingQqGroup] = useState(null);
  const [editingCarousel, setEditingCarousel] = useState(null);
  const [editingOpenSourceProject, setEditingOpenSourceProject] = useState(null);
  const [showAddCarousel, setShowAddCarousel] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [showAddVideo, setShowAddVideo] = useState(false);
  const [showAddDownload, setShowAddDownload] = useState(false);
  const [showAddAiLauncherResource, setShowAddAiLauncherResource] = useState(false);
  const [showAddQqGroup, setShowAddQqGroup] = useState(false);
  const [showAddOpenSourceProject, setShowAddOpenSourceProject] = useState(false);
  
  // 表单状态
  const [videoForm, setVideoForm] = useState({ title: '', url: '', bvid: '', description: '', thumbnail: '', embed_code: '', category: '', order_index: 0 });
  const [downloadForm, setDownloadForm] = useState({ title: '', platform: '百度网盘', url: '', description: '', video_ids: [], category: '', official_url: '', order_index: 0, visible: true });
  const [aiLauncherForm, setAiLauncherForm] = useState({ title: '', platform: '魔搭社区', url: '', description: '', video_ids: [], category: '', official_url: '', order_index: 0, visible: true });
  const [qqGroupForm, setQqGroupForm] = useState({ name: '', qq_number: '', order_index: 0 });
  const [carouselForm, setCarouselForm] = useState({
    title: '',
    subtitle: '',
    background_type: 'image',
    background_url: '',
    media_fit: 'cover',
    media_align: 'center',
    media_align_percent: 50,
    text_bg_enabled: false,
    text_bg_color: '#000000',
    text_bg_opacity: 40,
    text_bg_max_width_percent: 60,
    text_bg_padding_v: 16,
    text_bg_padding_h: 24,
    text_bg_radius: 16,
    link_url: '',
    switch_interval: 5,
    order_index: 0,
    visible: true
  });
  const [openSourceProjectForm, setOpenSourceProjectForm] = useState({ name: '', description: '', repo_url: '', download_url: '', category: '', order_index: 0, visible: true });
  const [passwordForm, setPasswordForm] = useState({ oldPassword: '', newPassword: '', confirmPassword: '' });
  const [carouselMediaList, setCarouselMediaList] = useState([]);
  
  // 批量操作状态
  const [selectedVideos, setSelectedVideos] = useState([]);
  const [selectedDownloads, setSelectedDownloads] = useState([]);
  const [selectedAiLauncherResources, setSelectedAiLauncherResources] = useState([]);
  const [batchCategory, setBatchCategory] = useState('');
  const [showBatchModal, setShowBatchModal] = useState(false);
  const [batchTable, setBatchTable] = useState('');
  const [activeMenu, setActiveMenu] = useState('carousel');
  const [toast, setToast] = useState({ show: false, message: '' });

  const showToast = (message) => setToast({ show: true, message });

  const preserveItemScroll = (selector) => {
    const el = document.getElementById(selector);
    if (!el) return null;
    const rect = el.getBoundingClientRect();
    return () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const newEl = document.getElementById(selector);
          if (newEl) {
            const newRect = newEl.getBoundingClientRect();
            window.scrollBy(0, newRect.top - rect.top);
          }
        });
      });
    };
  };

  useEffect(() => {
    if (!toast.show) return;
    const t = setTimeout(() => setToast((prev) => ({ ...prev, show: false })), 2500);
    return () => clearTimeout(t);
  }, [toast.show, toast.message]);

  const MENU_ITEMS = [
    { key: 'carousel', label: '首页轮播' },
    { key: 'profile', label: '品牌介绍' },
    { key: 'openSource', label: '开源项目' },
    { key: 'qqGroups', label: 'QQ群' },
    { key: 'videos', label: '视频管理' },
    { key: 'downloads', label: '资源中心' },
    { key: 'aiLauncher', label: 'AI创作助手' },
  ];

  useEffect(() => {
    checkAuth();
  }, []);

  useEffect(() => {
    if (authenticated) {
      fetchData();
    }
  }, [authenticated]);

  const checkAuth = async () => {
    try {
      const response = await axios.get('/api/check-auth');
      setAuthenticated(response.data.authenticated);
    } catch (error) {
      console.error('检查认证失败:', error);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const response = await axios.post('/api/login', { password });
      if (response.data.success) {
        setAuthenticated(true);
        setPassword('');
      }
    } catch (error) {
      setError('密码错误');
    }
  };

  const handleLogout = async () => {
    await axios.post('/api/logout');
    setAuthenticated(false);
  };

  const fetchData = async () => {
    try {
      const [profileRes, videosRes, downloadsRes, aiLauncherRes, qqGroupsRes, carouselRes, openSourceRes] = await Promise.all([
        axios.get('/api/profile'),
        axios.get('/api/videos'),
        axios.get('/api/downloads?visible_only=false'),
        axios.get('/api/ai-launcher?visible_only=false'),
        axios.get('/api/qq-groups'),
        axios.get('/api/home-carousel?visible_only=false'),
        axios.get('/api/open-source-projects?visible_only=false')
      ]);
      setProfile(profileRes.data.content);
      setVideos(videosRes.data);
      setDownloads(downloadsRes.data);
      setAiLauncherResources(Array.isArray(aiLauncherRes.data) ? aiLauncherRes.data : []);
      setQqGroups(Array.isArray(qqGroupsRes.data) ? qqGroupsRes.data : []);
      setCarouselItems(Array.isArray(carouselRes.data) ? carouselRes.data : []);
      setOpenSourceProjects(Array.isArray(openSourceRes.data) ? openSourceRes.data : []);
    } catch (error) {
      console.error('获取数据失败:', error);
    }
  };

  const handleSaveProfile = async () => {
    try {
      await axios.post('/api/profile', { content: profile });
      showToast('保存成功！');
    } catch (error) {
      showToast('保存失败！');
    }
  };

  const extractBvid = (url) => {
    // 从URL中提取BV号，保持原始大小写
    if (!url) return '';
    const match = url.match(/BV[a-zA-Z0-9]+/i);
    return match ? match[0] : ''; // 保持原始大小写，不转换
  };

  const handleVideoUrlChange = (url) => {
    const bvid = extractBvid(url);
    setVideoForm({ ...videoForm, url, bvid });
  };

  const handleSaveVideo = async () => {
    if (!videoForm.title || (!videoForm.bvid && !videoForm.embed_code)) {
      showToast('请填写标题和视频链接（或嵌入代码）！');
      return;
    }
    if (!videoForm.category || !videoForm.category.trim()) {
      showToast('请填写分类！');
      return;
    }
    try {
      const dataToSave = {
        title: videoForm.title,
        bvid: videoForm.bvid || '',
        description: videoForm.description || '',
        thumbnail: videoForm.thumbnail || '',
        embed_code: videoForm.embed_code || '',
        category: videoForm.category || '',
        order_index: videoForm.order_index || 0
      };
      const editingId = editingVideo;
      const restore = editingId ? preserveItemScroll(`video-${editingId}`) : null;
      if (editingId) {
        await axios.put(`/api/videos/${editingId}`, dataToSave);
      } else {
        await axios.post('/api/videos', dataToSave);
      }
      setEditingVideo(null);
      setShowAddVideo(false);
      setVideoForm({ title: '', url: '', bvid: '', description: '', thumbnail: '', embed_code: '', category: '', order_index: 0 });
      await fetchData();
      showToast('保存成功！');
      if (restore) setTimeout(restore, 100);
    } catch (error) {
      showToast('保存失败！');
    }
  };

  const handleDeleteVideo = async (id) => {
    try {
      await axios.delete(`/api/videos/${id}`);
      fetchData();
      showToast('已删除');
    } catch (error) {
      showToast('删除失败！');
    }
  };

  const handleSaveDownload = async () => {
    if (!downloadForm.title || !downloadForm.url) {
      showToast('请填写标题和链接！');
      return;
    }
    if (!downloadForm.category || !downloadForm.category.trim()) {
      showToast('请填写分类！');
      return;
    }
    try {
      const dataToSave = {
        ...downloadForm,
        video_ids: downloadForm.video_ids || [],
        visible: downloadForm.visible ? 1 : 0
      };
      const editingId = editingDownload;
      const restore = editingId ? preserveItemScroll(`download-${editingId}`) : null;
      if (editingId) {
        await axios.put(`/api/downloads/${editingId}`, dataToSave);
      } else {
        await axios.post('/api/downloads', dataToSave);
      }
      setEditingDownload(null);
      setShowAddDownload(false);
      setDownloadForm({ title: '', platform: '百度网盘', url: '', description: '', video_ids: [], category: '', official_url: '', order_index: 0, visible: true });
      await fetchData();
      showToast('保存成功！');
      if (restore) setTimeout(restore, 100);
    } catch (error) {
      showToast('保存失败！');
    }
  };

  const handleDeleteDownload = async (id) => {
    try {
      await axios.delete(`/api/downloads/${id}`);
      fetchData();
      showToast('已删除');
    } catch (error) {
      showToast('删除失败！');
    }
  };

  const handleSaveAiLauncherResource = async () => {
    if (!aiLauncherForm.title || !aiLauncherForm.url) {
      showToast('请填写标题和链接！');
      return;
    }
    if (!aiLauncherForm.category || !aiLauncherForm.category.trim()) {
      showToast('请填写分类！');
      return;
    }
    try {
      const dataToSave = {
        ...aiLauncherForm,
        video_ids: aiLauncherForm.video_ids || [],
        visible: aiLauncherForm.visible ? 1 : 0
      };
      const editingId = editingAiLauncherResource;
      const restore = editingId ? preserveItemScroll(`ai-launcher-resource-${editingId}`) : null;
      if (editingId) {
        await axios.put(`/api/ai-launcher/${editingId}`, dataToSave);
      } else {
        await axios.post('/api/ai-launcher', dataToSave);
      }
      setEditingAiLauncherResource(null);
      setShowAddAiLauncherResource(false);
      setAiLauncherForm({ title: '', platform: '魔搭社区', url: '', description: '', video_ids: [], category: '', official_url: '', order_index: 0, visible: true });
      await fetchData();
      showToast('保存成功！');
      if (restore) setTimeout(restore, 100);
    } catch (error) {
      showToast('保存失败！');
    }
  };

  const handleDeleteAiLauncherResource = async (id) => {
    try {
      await axios.delete(`/api/ai-launcher/${id}`);
      fetchData();
      showToast('已删除');
    } catch (error) {
      showToast('删除失败！');
    }
  };

  const startEditAiLauncherResource = (resource) => {
    setEditingAiLauncherResource(resource.id);
    setShowAddAiLauncherResource(false);
    setAiLauncherForm({
      title: resource.title,
      platform: resource.platform,
      url: resource.url,
      description: resource.description || '',
      video_ids: resource.video_ids || (resource.video_id ? [resource.video_id] : []),
      category: resource.category || '',
      official_url: resource.official_url || '',
      order_index: resource.order_index || 0,
      visible: resource.visible !== undefined ? (resource.visible === 1 || resource.visible === true) : true
    });
    setTimeout(() => {
      const element = document.getElementById(`ai-launcher-resource-${resource.id}`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }, 100);
  };

  const handleToggleAiLauncherVisibility = async (resource) => {
    try {
      const newVisible = !(resource.visible === 1 || resource.visible === true);
      await axios.put(`/api/ai-launcher/${resource.id}`, {
        ...resource,
        visible: newVisible ? 1 : 0
      });
      fetchData();
      showToast('状态更新成功！');
    } catch (error) {
      showToast('状态更新失败！');
    }
  };

  const handleSaveQqGroup = async () => {
    const name = qqGroupForm.name.trim();
    const qqNumber = qqGroupForm.qq_number.trim();
    const orderIndex = Number.isNaN(parseInt(qqGroupForm.order_index, 10))
      ? 0
      : parseInt(qqGroupForm.order_index, 10);

    if (!name || !qqNumber) {
      showToast('请填写群名称和群号！');
      return;
    }

    try {
      const payload = {
        name,
        qq_number: qqNumber,
        order_index: orderIndex
      };
      const editingId = editingQqGroup;
      const restore = editingId ? preserveItemScroll(`qq-group-${editingId}`) : null;
      if (editingId) {
        await axios.put(`/api/qq-groups/${editingId}`, payload);
      } else {
        await axios.post('/api/qq-groups', payload);
      }
      setEditingQqGroup(null);
      setShowAddQqGroup(false);
      setQqGroupForm({ name: '', qq_number: '', order_index: 0 });
      await fetchData();
      showToast('保存成功！');
      if (restore) setTimeout(restore, 100);
    } catch (error) {
      showToast(error.response?.data?.message || '保存失败！');
    }
  };

  const handleDeleteQqGroup = async (id) => {
    try {
      await axios.delete(`/api/qq-groups/${id}`);
      fetchData();
      showToast('已删除');
    } catch (error) {
      showToast('删除失败！');
    }
  };

  const handleSaveOpenSourceProject = async () => {
    const name = openSourceProjectForm.name.trim();
    const repoUrl = openSourceProjectForm.repo_url.trim();
    if (!name || !repoUrl) {
      showToast('请填写名称和仓库地址！');
      return;
    }
    try {
      const payload = {
        name,
        description: openSourceProjectForm.description || '',
        repo_url: repoUrl,
        download_url: openSourceProjectForm.download_url || '',
        category: openSourceProjectForm.category || '',
        order_index: parseInt(openSourceProjectForm.order_index, 10) || 0,
        visible: openSourceProjectForm.visible ? 1 : 0
      };
      const editingId = editingOpenSourceProject;
      const restore = editingId ? preserveItemScroll(`open-source-project-${editingId}`) : null;
      if (editingId) {
        await axios.put(`/api/open-source-projects/${editingId}`, payload);
      } else {
        await axios.post('/api/open-source-projects', payload);
      }
      setEditingOpenSourceProject(null);
      setShowAddOpenSourceProject(false);
      setOpenSourceProjectForm({ name: '', description: '', repo_url: '', download_url: '', category: '', order_index: 0, visible: true });
      await fetchData();
      showToast('保存成功！');
      if (restore) setTimeout(restore, 100);
    } catch (error) {
      showToast(error.response?.data?.message || '保存失败！');
    }
  };

  const handleDeleteOpenSourceProject = async (id) => {
    try {
      await axios.delete(`/api/open-source-projects/${id}`);
      fetchData();
      showToast('已删除');
    } catch (error) {
      showToast('删除失败！');
    }
  };

  const startEditOpenSourceProject = (project) => {
    setEditingOpenSourceProject(project.id);
    setShowAddOpenSourceProject(false);
    setOpenSourceProjectForm({
      name: project.name || '',
      description: project.description || '',
      repo_url: project.repo_url || '',
      download_url: project.download_url || '',
      category: project.category || '',
      order_index: project.order_index ?? 0,
      visible: project.visible !== undefined ? (project.visible === 1 || project.visible === true) : true
    });
    setTimeout(() => {
      const el = document.getElementById(`open-source-project-${project.id}`);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 100);
  };

  const handleSaveCarousel = async () => {
    if (!carouselForm.title?.trim()) {
      showToast('请填写标题！');
      return;
    }
    try {
      const payload = {
        title: carouselForm.title.trim(),
        subtitle: carouselForm.subtitle || '',
        background_type: carouselForm.background_type || 'image',
        background_url: carouselForm.background_url || '',
        media_fit: carouselForm.media_fit || 'cover',
        media_align: carouselForm.media_align || 'center',
        media_align_percent: parseInt(carouselForm.media_align_percent, 10) || 50,
        text_bg_enabled: carouselForm.text_bg_enabled ? 1 : 0,
        text_bg_color: carouselForm.text_bg_color || '#000000',
        text_bg_opacity: parseInt(carouselForm.text_bg_opacity, 10) || 40,
        text_bg_max_width_percent: parseInt(carouselForm.text_bg_max_width_percent, 10) || 60,
        text_bg_padding_v: parseInt(carouselForm.text_bg_padding_v, 10) || 16,
        text_bg_padding_h: parseInt(carouselForm.text_bg_padding_h, 10) || 24,
        text_bg_radius: parseInt(carouselForm.text_bg_radius, 10) || 16,
        media_play_mode: carouselForm.media_play_mode || 'sequence',
        transition_type: carouselForm.transition_type || 'fade',
        link_url: carouselForm.link_url || '',
        switch_interval: parseInt(carouselForm.switch_interval, 10) || 5,
        order_index: parseInt(carouselForm.order_index, 10) || 0,
        visible: carouselForm.visible ? 1 : 0
      };
      const editingId = editingCarousel;
      const restore = editingId ? preserveItemScroll(`carousel-${editingId}`) : null;

      let carouselId = editingId;
      if (editingId) {
        await axios.put(`/api/home-carousel/${editingId}`, payload);
      } else {
        const res = await axios.post('/api/home-carousel', payload);
        carouselId = res.data?.id;
      }

      if (carouselId) {
        await axios.post(`/api/home-carousel/${carouselId}/media`, {
          media_list: (carouselMediaList || []).map((m, index) => ({
            media_type: m.media_type || 'image',
            url: m.url || '',
            media_fit: m.media_fit || 'cover',
            media_align: m.media_align || 'center',
            media_align_percent: parseInt(m.media_align_percent, 10) || 50,
            order_index: typeof m.order_index === 'number' ? m.order_index : index,
            visible: m.visible !== undefined ? (m.visible ? 1 : 0) : 1
          })).filter((m) => m.url)
        });
      }

      setEditingCarousel(null);
      setShowAddCarousel(false);
      setCarouselForm({
        title: '',
        subtitle: '',
        background_type: 'image',
        background_url: '',
        media_fit: 'cover',
        media_align: 'center',
        media_align_percent: 50,
        text_bg_enabled: false,
        text_bg_color: '#000000',
        text_bg_opacity: 40,
        text_bg_max_width_percent: 60,
        text_bg_padding_v: 16,
        text_bg_padding_h: 24,
        text_bg_radius: 16,
        media_play_mode: 'sequence',
        transition_type: 'fade',
        link_url: '',
        switch_interval: 5,
        order_index: 0,
        visible: true
      });
      setCarouselMediaList([]);
      await fetchData();
      showToast('保存成功！');
      if (restore) setTimeout(restore, 100);
    } catch (error) {
      showToast('保存失败！');
    }
  };

  const handleDeleteCarousel = async (id) => {
    try {
      await axios.delete(`/api/home-carousel/${id}`);
      fetchData();
      showToast('已删除');
    } catch (error) {
      showToast('删除失败！');
    }
  };

  const startEditCarousel = (item) => {
    setEditingCarousel(item.id);
    setShowAddCarousel(true);
    setCarouselForm({
      title: item.title || '',
      subtitle: item.subtitle || '',
      background_type: item.background_type || 'image',
      background_url: item.background_url || '',
      media_fit: item.media_fit || 'cover',
      media_align: item.media_align || 'center',
      media_align_percent: item.media_align_percent ?? 50,
      text_bg_enabled: item.text_bg_enabled !== undefined ? (item.text_bg_enabled === 1 || item.text_bg_enabled === true) : false,
      text_bg_color: item.text_bg_color || '#000000',
      text_bg_opacity: item.text_bg_opacity ?? 40,
      text_bg_max_width_percent: item.text_bg_max_width_percent ?? 60,
      text_bg_padding_v: item.text_bg_padding_v ?? 16,
      text_bg_padding_h: item.text_bg_padding_h ?? 24,
      text_bg_radius: item.text_bg_radius ?? 16,
      media_play_mode: item.media_play_mode || 'sequence',
      transition_type: item.transition_type || 'fade',
      link_url: item.link_url || '',
      switch_interval: item.switch_interval ?? 5,
      order_index: item.order_index ?? 0,
      visible: item.visible !== undefined ? (item.visible === 1 || item.visible === true) : true
    });
    setCarouselMediaList(Array.isArray(item.media_list) ? item.media_list : []);
  };

  const startEditQqGroup = (group) => {
    setEditingQqGroup(group.id);
    setShowAddQqGroup(false);
    setQqGroupForm({
      name: group.name || '',
      qq_number: group.qq_number || '',
      order_index: group.order_index ?? 0
    });
    setTimeout(() => {
      const element = document.getElementById(`qq-group-${group.id}`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }, 100);
  };

  const handleChangePassword = async () => {
    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      showToast('两次输入的密码不一致！');
      return;
    }
    try {
      await axios.post('/api/change-password', {
        oldPassword: passwordForm.oldPassword,
        newPassword: passwordForm.newPassword
      });
      setShowPasswordModal(false);
      setPasswordForm({ oldPassword: '', newPassword: '', confirmPassword: '' });
      showToast('密码修改成功！');
    } catch (error) {
      showToast(error.response?.data?.message || '密码修改失败！');
    }
  };

  const startEditVideo = (video) => {
    setEditingVideo(video.id);
    setShowAddVideo(false);
    setVideoForm({
      title: video.title,
      url: video.bvid ? `https://www.bilibili.com/video/${video.bvid}` : '',
      bvid: video.bvid || '',
      description: video.description || '',
      thumbnail: video.thumbnail || '',
      embed_code: video.embed_code || '',
      category: video.category || '',
      order_index: video.order_index || 0
    });
    // 滚动到编辑位置
    setTimeout(() => {
      const element = document.getElementById(`video-${video.id}`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }, 100);
  };

  const startEditDownload = (download) => {
    setEditingDownload(download.id);
    setShowAddDownload(false);
    setDownloadForm({
      title: download.title,
      platform: download.platform,
      url: download.url,
      description: download.description || '',
      video_ids: download.video_ids || (download.video_id ? [download.video_id] : []),
      category: download.category || '',
      official_url: download.official_url || '',
      order_index: download.order_index || 0,
      visible: download.visible !== undefined ? (download.visible === 1 || download.visible === true) : true
    });
    // 滚动到编辑位置
    setTimeout(() => {
      const element = document.getElementById(`download-${download.id}`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }, 100);
  };

  const handleToggleVisibility = async (download) => {
    try {
      const newVisible = !(download.visible === 1 || download.visible === true);
      await axios.put(`/api/downloads/${download.id}`, {
        ...download,
        visible: newVisible ? 1 : 0
      });
      fetchData();
      showToast('状态更新成功！');
    } catch (error) {
      showToast('状态更新失败！');
    }
  };

  if (!authenticated) {
    return (
      <div className="admin-container fade-in">
        <div className="login-card">
          <h2>管理员登录</h2>
          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label>密码</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoFocus
              />
            </div>
            {error && <div className="error-message">{error}</div>}
            <button type="submit" className="submit-btn">登录</button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-container fade-in">
      <div className="admin-header">
        <h1>后台管理</h1>
        <div className="admin-actions">
          <button onClick={() => setShowPasswordModal(true)} className="action-btn">修改密码</button>
          <button onClick={handleLogout} className="action-btn secondary">退出登录</button>
        </div>
      </div>

      <div className="admin-layout">
        <nav className="admin-sidebar">
          {MENU_ITEMS.map((item) => (
            <button
              key={item.key}
              type="button"
              className={`admin-nav-item ${activeMenu === item.key ? 'active' : ''}`}
              onClick={() => setActiveMenu(item.key)}
            >
              {item.label}
            </button>
          ))}
        </nav>
        <main className="admin-main">
          {/* 批量设置分类模态框 */}
      {showBatchModal && (
        <div className="modal-overlay" onClick={() => setShowBatchModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>批量设置分类</h3>
            <div className="form-group">
              <label>分类名称</label>
              <input
                type="text"
                value={batchCategory}
                onChange={(e) => setBatchCategory(e.target.value)}
                placeholder="请输入分类名称"
              />
            </div>
            <div className="modal-actions">
              <button 
                onClick={async () => {
                  if (!batchCategory.trim()) {
                    showToast('请输入分类名称');
                    return;
                  }
                  try {
                    let ids = [];
                    if (batchTable === 'videos') ids = selectedVideos;
                    else if (batchTable === 'downloads') ids = selectedDownloads;
                    else if (batchTable === 'ai_launcher_resources') ids = selectedAiLauncherResources;
                    await axios.post('/api/batch-update-category', {
                      table: batchTable,
                      ids: ids,
                      category: batchCategory
                    });
                    setShowBatchModal(false);
                    setBatchCategory('');
                    if (batchTable === 'videos') setSelectedVideos([]);
                    else if (batchTable === 'downloads') setSelectedDownloads([]);
                    else if (batchTable === 'ai_launcher_resources') setSelectedAiLauncherResources([]);
                    fetchData();
                    showToast('批量设置成功！');
                  } catch (error) {
                    showToast('批量设置失败！');
                  }
                }} 
                className="submit-btn"
              >
                确定
              </button>
              <button onClick={() => {
                setShowBatchModal(false);
                setBatchCategory('');
              }} className="cancel-btn">取消</button>
            </div>
          </div>
        </div>
      )}

      {/* 修改密码模态框 */}
      {showPasswordModal && (
        <div className="modal-overlay" onClick={() => setShowPasswordModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>修改密码</h3>
            <div className="form-group">
              <label>原密码</label>
              <input
                type="password"
                value={passwordForm.oldPassword}
                onChange={(e) => setPasswordForm({ ...passwordForm, oldPassword: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label>新密码</label>
              <input
                type="password"
                value={passwordForm.newPassword}
                onChange={(e) => setPasswordForm({ ...passwordForm, newPassword: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label>确认新密码</label>
              <input
                type="password"
                value={passwordForm.confirmPassword}
                onChange={(e) => setPasswordForm({ ...passwordForm, confirmPassword: e.target.value })}
              />
            </div>
            <div className="modal-actions">
              <button onClick={handleChangePassword} className="submit-btn">确定</button>
              <button onClick={() => setShowPasswordModal(false)} className="cancel-btn">取消</button>
            </div>
          </div>
        </div>
      )}

      {activeMenu === 'carousel' && (
      <div className="admin-section">
        <h2>首页轮播管理</h2>
        <p className="section-desc" style={{ color: 'var(--text-secondary)', marginBottom: '1rem' }}>
          轮播展示在首页「关于我们」卡片上方，可配置背景图/视频、标题、副标题、点击跳转链接、每张切换时间。链接示例：<code style={{ background: 'var(--bg-color)', padding: '0.2rem 0.4rem', borderRadius: 4 }}>/downloads?category=整合包</code>、<code style={{ background: 'var(--bg-color)', padding: '0.2rem 0.4rem', borderRadius: 4 }}>/downloads?highlight=123</code>（定位到资源中心某下载项）、<code style={{ background: 'var(--bg-color)', padding: '0.2rem 0.4rem', borderRadius: 4 }}>/ai-launcher?highlight=456</code>（定位到AI创作助手某资源）。
        </p>
        <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem', flexWrap: 'wrap' }}>
          <button
            onClick={() => {
              setEditingCarousel(null);
              setShowAddCarousel(true);
              setCarouselForm({
                title: '',
                subtitle: '',
                background_type: 'image',
                background_url: '',
                media_fit: 'cover',
                media_align: 'center',
                media_align_percent: 50,
                text_bg_enabled: false,
                text_bg_color: '#000000',
                text_bg_opacity: 40,
                text_bg_max_width_percent: 60,
                text_bg_padding_v: 16,
                text_bg_padding_h: 24,
                text_bg_radius: 16,
                link_url: '',
                switch_interval: 5,
                order_index: 0,
                visible: true
              });
            }}
            className="add-btn"
          >
            添加轮播
          </button>
        </div>

        {(showAddCarousel || editingCarousel) && (
          <div className="form-card">
            <div className="form-group">
              <label>标题 <span style={{ color: 'red' }}>*</span></label>
              <input
                type="text"
                value={carouselForm.title}
                onChange={(e) => setCarouselForm({ ...carouselForm, title: e.target.value })}
                placeholder="轮播卡片标题"
              />
            </div>
            <div className="form-group">
              <label>副标题</label>
              <input
                type="text"
                value={carouselForm.subtitle}
                onChange={(e) => setCarouselForm({ ...carouselForm, subtitle: e.target.value })}
                placeholder="轮播卡片副标题（可选）"
              />
            </div>
            <div className="form-group">
              <label>背景类型</label>
              <select
                value={carouselForm.background_type}
                onChange={(e) => setCarouselForm({ ...carouselForm, background_type: e.target.value })}
              >
                <option value="image">图片</option>
                <option value="video">视频</option>
              </select>
            </div>
            <div className="form-group">
              <label>垂直裁切位置</label>
              <select
                value={carouselForm.media_align || 'center'}
                onChange={(e) => setCarouselForm({ ...carouselForm, media_align: e.target.value })}
              >
                <option value="top">顶部</option>
                <option value="center">中间（默认）</option>
                <option value="bottom">底部</option>
                <option value="custom">自定义百分比</option>
              </select>
            </div>
            {carouselForm.media_align === 'custom' && (
              <div className="form-group">
                <label>自定义垂直百分比（0=最上，100=最下）</label>
                <input
                  type="number"
                  min={0}
                  max={100}
                  value={carouselForm.media_align_percent}
                  onChange={(e) => {
                    const v = parseInt(e.target.value, 10);
                    const clamped = Number.isNaN(v) ? 50 : Math.min(100, Math.max(0, v));
                    setCarouselForm({ ...carouselForm, media_align_percent: clamped });
                  }}
                />
              </div>
            )}
            <div className="form-group">
              <label>媒体适配方式</label>
              <select
                value={carouselForm.media_fit || 'cover'}
                onChange={(e) => setCarouselForm({ ...carouselForm, media_fit: e.target.value })}
              >
                <option value="cover">裁切铺满（推荐）</option>
                <option value="contain">完整显示（可能留黑边）</option>
                <option value="fill">拉伸铺满（可能变形）</option>
                <option value="center">原始尺寸居中</option>
              </select>
            </div>
            <div className="form-group">
              <label>
                <input
                  type="checkbox"
                  checked={carouselForm.text_bg_enabled}
                  onChange={(e) => setCarouselForm({ ...carouselForm, text_bg_enabled: e.target.checked })}
                  style={{ marginRight: '0.5rem' }}
                />
                启用标题背景框
              </label>
            </div>
            {carouselForm.text_bg_enabled && (
              <>
                <div className="form-group">
                  <label>背景颜色</label>
                  <input
                    type="color"
                    value={carouselForm.text_bg_color}
                    onChange={(e) => setCarouselForm({ ...carouselForm, text_bg_color: e.target.value || '#000000' })}
                    style={{ width: '60px', padding: 0, borderRadius: 8, cursor: 'pointer' }}
                  />
                </div>
                <div className="form-group">
                  <label>背景不透明度（0-100）</label>
                  <input
                    type="number"
                    min={0}
                    max={100}
                    value={carouselForm.text_bg_opacity}
                    onChange={(e) => {
                      const v = parseInt(e.target.value, 10);
                      const clamped = Number.isNaN(v) ? 40 : Math.min(100, Math.max(0, v));
                      setCarouselForm({ ...carouselForm, text_bg_opacity: clamped });
                    }}
                  />
                </div>
                <div className="form-group">
                  <label>最大宽度（占轮播宽度百分比）</label>
                  <input
                    type="number"
                    min={10}
                    max={100}
                    value={carouselForm.text_bg_max_width_percent}
                    onChange={(e) => {
                      const v = parseInt(e.target.value, 10);
                      const clamped = Number.isNaN(v) ? 60 : Math.min(100, Math.max(10, v));
                      setCarouselForm({ ...carouselForm, text_bg_max_width_percent: clamped });
                    }}
                  />
                </div>
                <div className="form-group">
                  <label>上下内边距（px）</label>
                  <input
                    type="number"
                    min={0}
                    max={200}
                    value={carouselForm.text_bg_padding_v}
                    onChange={(e) => {
                      const v = parseInt(e.target.value, 10);
                      const clamped = Number.isNaN(v) ? 16 : Math.min(200, Math.max(0, v));
                      setCarouselForm({ ...carouselForm, text_bg_padding_v: clamped });
                    }}
                  />
                </div>
                <div className="form-group">
                  <label>左右内边距（px）</label>
                  <input
                    type="number"
                    min={0}
                    max={400}
                    value={carouselForm.text_bg_padding_h}
                    onChange={(e) => {
                      const v = parseInt(e.target.value, 10);
                      const clamped = Number.isNaN(v) ? 24 : Math.min(400, Math.max(0, v));
                      setCarouselForm({ ...carouselForm, text_bg_padding_h: clamped });
                    }}
                  />
                </div>
                <div className="form-group">
                  <label>圆角（px）</label>
                  <input
                    type="number"
                    min={0}
                    max={200}
                    value={carouselForm.text_bg_radius}
                    onChange={(e) => {
                      const v = parseInt(e.target.value, 10);
                      const clamped = Number.isNaN(v) ? 16 : Math.min(200, Math.max(0, v));
                      setCarouselForm({ ...carouselForm, text_bg_radius: clamped });
                    }}
                  />
                </div>
              </>
            )}
            <div className="form-group">
              <label>媒体播放模式</label>
              <select
                value={carouselForm.media_play_mode || 'sequence'}
                onChange={(e) => setCarouselForm({ ...carouselForm, media_play_mode: e.target.value })}
              >
                <option value="sequence">顺序播放</option>
                <option value="shuffle">随机（洗牌）</option>
              </select>
            </div>
            <div className="form-group">
              <label>背景URL（图片或视频地址）</label>
              <input
                type="text"
                value={carouselForm.background_url}
                onChange={(e) => setCarouselForm({ ...carouselForm, background_url: e.target.value })}
                placeholder="https://example.com/banner.jpg 或 /images/banner.jpg（需放于 frontend/public/images/）"
              />
              <small style={{ color: 'var(--text-secondary)', display: 'block', marginTop: '0.5rem' }}>
                单媒体模式下使用。多媒体模式请在下方「媒体列表」中配置多个图片/视频。
              </small>
            </div>
            <div className="form-group">
              <label>媒体列表（多媒体模式）</label>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                {carouselMediaList.map((m, index) => (
                  <div
                    key={m.id || index}
                    style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: '0.5rem',
                      alignItems: 'center',
                      padding: '0.5rem 0',
                      borderBottom: '1px dashed var(--border-color)'
                    }}
                  >
                    <select
                      value={m.media_type || 'image'}
                      onChange={(e) => {
                        const next = [...carouselMediaList];
                        next[index] = { ...next[index], media_type: e.target.value };
                        setCarouselMediaList(next);
                      }}
                      style={{ minWidth: 80 }}
                    >
                      <option value="image">图片</option>
                      <option value="video">视频</option>
                    </select>
                    <input
                      type="text"
                      value={m.url || ''}
                      onChange={(e) => {
                        const next = [...carouselMediaList];
                        next[index] = { ...next[index], url: e.target.value };
                        setCarouselMediaList(next);
                      }}
                      placeholder="媒体 URL"
                      style={{ flex: 1, minWidth: 200 }}
                    />
                    <select
                      value={m.media_fit || 'cover'}
                      onChange={(e) => {
                        const next = [...carouselMediaList];
                        next[index] = { ...next[index], media_fit: e.target.value };
                        setCarouselMediaList(next);
                      }}
                    >
                      <option value="cover">裁切铺满</option>
                      <option value="contain">完整显示</option>
                      <option value="fill">拉伸铺满</option>
                      <option value="center">原始尺寸居中</option>
                    </select>
                    <select
                      value={m.media_align || 'center'}
                      onChange={(e) => {
                        const next = [...carouselMediaList];
                        next[index] = { ...next[index], media_align: e.target.value };
                        setCarouselMediaList(next);
                      }}
                    >
                      <option value="top">顶部</option>
                      <option value="center">中间</option>
                      <option value="bottom">底部</option>
                      <option value="custom">自定义</option>
                    </select>
                    {m.media_align === 'custom' && (
                      <input
                        type="number"
                        min={0}
                        max={100}
                        value={m.media_align_percent ?? 50}
                        onChange={(e) => {
                          const v = parseInt(e.target.value, 10);
                          const clamped = Number.isNaN(v) ? 50 : Math.min(100, Math.max(0, v));
                          const next = [...carouselMediaList];
                          next[index] = { ...next[index], media_align_percent: clamped };
                          setCarouselMediaList(next);
                        }}
                        placeholder="%"
                        style={{ width: 70 }}
                      />
                    )}
                    <input
                      type="number"
                      value={m.order_index ?? index}
                      onChange={(e) => {
                        const v = parseInt(e.target.value, 10);
                        const next = [...carouselMediaList];
                        next[index] = { ...next[index], order_index: Number.isNaN(v) ? index : v };
                        setCarouselMediaList(next);
                      }}
                      style={{ width: 70 }}
                      placeholder="排序"
                    />
                    <button
                      type="button"
                      className="delete-btn"
                      onClick={() => {
                        const next = carouselMediaList.filter((_, i) => i !== index);
                        setCarouselMediaList(next);
                      }}
                    >
                      删除
                    </button>
                  </div>
                ))}
                <button
                  type="button"
                  className="add-btn"
                  style={{ padding: '0.4rem 0.8rem', alignSelf: 'flex-start' }}
                  onClick={() => {
                    setCarouselMediaList([
                      ...carouselMediaList,
                      {
                        media_type: 'image',
                        url: '',
                        media_fit: carouselForm.media_fit || 'cover',
                        media_align: carouselForm.media_align || 'center',
                        media_align_percent: carouselForm.media_align_percent || 50,
                        order_index: carouselMediaList.length,
                        visible: 1
                      }
                    ]);
                  }}
                >
                  添加媒体
                </button>
              </div>
            </div>
            <div className="form-group">
              <label>点击跳转链接</label>
              <input
                type="text"
                value={carouselForm.link_url}
                onChange={(e) => setCarouselForm({ ...carouselForm, link_url: e.target.value })}
                placeholder="/downloads 或 https://... 或 /downloads?highlight=123"
              />
              <small style={{ color: 'var(--text-secondary)', display: 'block', marginTop: '0.5rem' }}>
                留空则点击不跳转。站内路径如 /downloads、/ai-launcher?category=xxx、/downloads?highlight=123 可跳转到具体资源
              </small>
            </div>
            <div className="form-group">
              <label>切换间隔（秒）</label>
              <input
                type="number"
                min={2}
                value={carouselForm.switch_interval}
                onChange={(e) => setCarouselForm({ ...carouselForm, switch_interval: parseInt(e.target.value, 10) || 5 })}
              />
            </div>
            <div className="form-group">
              <label>排序（数字越小越靠前）</label>
              <input
                type="number"
                value={carouselForm.order_index}
                onChange={(e) => setCarouselForm({ ...carouselForm, order_index: parseInt(e.target.value, 10) || 0 })}
              />
            </div>
            <div className="form-group">
              <label>
                <input
                  type="checkbox"
                  checked={carouselForm.visible}
                  onChange={(e) => setCarouselForm({ ...carouselForm, visible: e.target.checked })}
                  style={{ marginRight: '0.5rem' }}
                />
                显示
              </label>
            </div>
            <div className="form-group">
              <label>快捷选择跳转目标（可选）</label>
              <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', marginBottom: '0.5rem' }}>
                <select
                  onChange={(e) => {
                    const v = e.target.value;
                    if (v) setCarouselForm((f) => ({ ...f, link_url: v }));
                    e.target.value = '';
                  }}
                  style={{ padding: '0.5rem', borderRadius: 8, border: '1px solid var(--border-color)', background: 'var(--bg-color)', color: 'var(--text-primary)', minWidth: 300 }}
                >
                  <option value="">-- 选择卡片自动填入链接 --</option>
                  <optgroup label="AI创作助手">
                    {aiLauncherResources
                      .filter((r) => r.visible === 1 || r.visible === true)
                      .flatMap((r) => {
                        const vids = (r.video_ids && r.video_ids.length) ? r.video_ids : (r.video_id ? [r.video_id] : []);
                        if (vids.filter(Boolean).length === 0) {
                          const cat = r.category || '未分类';
                          return [(
                            <option key={`a-${r.id}-unassigned`} value={`/ai-launcher?category=${encodeURIComponent(cat)}&video=unassigned`} title={r.title}>
                              〔{cat}〕{r.title}（通用资源）
                            </option>
                          )];
                        }
                        return vids.filter(Boolean).map((vid) => (
                          <option key={`a-${r.id}-${vid}`} value={`/ai-launcher?video=${vid}`} title={r.title}>
                            〔{r.category || '未分类'}〕{r.title}
                          </option>
                        ));
                      })}
                  </optgroup>
                  <optgroup label="资源中心">
                    {downloads
                      .filter((d) => d.visible === 1 || d.visible === true)
                      .flatMap((d) => {
                        const vids = (d.video_ids && d.video_ids.length) ? d.video_ids : (d.video_id ? [d.video_id] : []);
                        if (vids.filter(Boolean).length === 0) {
                          const cat = d.category || '未分类';
                          return [(
                            <option key={`d-${d.id}-unassigned`} value={`/downloads?category=${encodeURIComponent(cat)}&video=unassigned`} title={d.title}>
                              〔{cat}〕{d.title}（通用资源）
                            </option>
                          )];
                        }
                        return vids.filter(Boolean).map((vid) => (
                          <option key={`d-${d.id}-${vid}`} value={`/downloads?video=${vid}`} title={d.title}>
                            〔{d.category || '未分类'}〕{d.title}
                          </option>
                        ));
                      })}
                  </optgroup>
                </select>
              </div>
              <small style={{ color: 'var(--text-secondary)' }}>格式：〔分类〕卡片名；通用资源（未关联视频）会带上「（通用资源）」标注</small>
            </div>
            <div className="form-actions">
              <button onClick={handleSaveCarousel} className="submit-btn">保存</button>
              <button
                onClick={() => {
                  setShowAddCarousel(false);
                  setEditingCarousel(null);
                  setCarouselForm({
                    title: '',
                    subtitle: '',
                    background_type: 'image',
                    background_url: '',
                    media_fit: 'cover',
                    media_align: 'center',
                    media_align_percent: 50,
                    text_bg_enabled: false,
                    text_bg_color: '#000000',
                    text_bg_opacity: 40,
                    text_bg_max_width_percent: 60,
                    text_bg_padding_v: 16,
                    text_bg_padding_h: 24,
                    text_bg_radius: 16,
                    link_url: '',
                    switch_interval: 5,
                    order_index: 0,
                    visible: true
                  });
                }}
                className="cancel-btn"
              >
                取消
              </button>
            </div>
          </div>
        )}

        <div className="items-list" style={{ marginTop: '1rem' }}>
          {carouselItems.length === 0 ? (
            <div className="empty-tip">暂无轮播，点击「添加轮播」创建</div>
          ) : (
            carouselItems.map((item) => (
              <div key={item.id} id={`carousel-${item.id}`} className="item-card" style={{ marginBottom: '0.5rem' }}>
                <div className="item-info" style={{ flex: 1 }}>
                  <h4>{item.title}</h4>
                  {item.subtitle && <p style={{ color: 'var(--text-secondary)', marginTop: '0.25rem' }}>{item.subtitle}</p>}
                  <p style={{ fontSize: '0.9rem', color: 'var(--text-secondary)', marginTop: '0.5rem' }}>
                    背景: {item.background_type} | 适配: {item.media_fit || 'cover'} | 对齐: {item.media_align || 'center'}{item.media_align === 'custom' && `(${item.media_align_percent ?? 50}%)`} | 链接: {item.link_url || '无'} | 间隔: {item.switch_interval}秒
                  </p>
                  {item.text_bg_enabled ? (
                    <p style={{ fontSize: '0.85rem', color: 'var(--text-secondary)', marginTop: '0.25rem' }}>
                      文本背景：启用，颜色 {item.text_bg_color || '#000000'}，不透明度 {item.text_bg_opacity ?? 40}% ，宽度 {item.text_bg_max_width_percent ?? 60}% ，圆角 {item.text_bg_radius ?? 16}px
                    </p>
                  ) : (
                    <p style={{ fontSize: '0.85rem', color: 'var(--text-secondary)', marginTop: '0.25rem' }}>
                      文本背景：未启用
                    </p>
                  )}
                </div>
                <div className="item-actions">
                  <button onClick={() => startEditCarousel(item)} className="edit-btn">编辑</button>
                  <button onClick={() => handleDeleteCarousel(item.id)} className="delete-btn">删除</button>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
      )}

      {activeMenu === 'profile' && (
      <div className="admin-section">
        <h2>品牌介绍</h2>
        <textarea
          value={profile}
          onChange={(e) => setProfile(e.target.value)}
          rows={6}
          className="form-textarea"
        />
        <button onClick={handleSaveProfile} className="submit-btn">保存</button>
      </div>
      )}

      {activeMenu === 'openSource' && (
      <div className="admin-section">
        <h2>开源项目管理</h2>
        <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', marginBottom: '1rem' }}>
          用于开源社区页面展示，如 ComfyUI 节点、扩展、工具等，对应 <a href="https://github.com/MechaBabyAi" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--primary-color)' }}>GitHub @MechaBabyAi</a>
        </p>
        <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem', flexWrap: 'wrap' }}>
          <button
            onClick={() => {
              setEditingOpenSourceProject(null);
              setShowAddOpenSourceProject(true);
              setOpenSourceProjectForm({ name: '', description: '', repo_url: '', download_url: '', category: '', order_index: 0, visible: true });
            }}
            className="add-btn"
          >
            添加开源项目
          </button>
        </div>

        {showAddOpenSourceProject && (
          <div className="form-card">
            <div className="form-group">
              <label>名称 <span style={{ color: 'red' }}>*</span></label>
              <input
                type="text"
                value={openSourceProjectForm.name}
                onChange={(e) => setOpenSourceProjectForm({ ...openSourceProjectForm, name: e.target.value })}
                placeholder="如：ComfyUI-MechaBabyNodeSearch"
              />
            </div>
            <div className="form-group">
              <label>简介</label>
              <textarea
                value={openSourceProjectForm.description}
                onChange={(e) => setOpenSourceProjectForm({ ...openSourceProjectForm, description: e.target.value })}
                rows={3}
                placeholder="项目简短介绍"
              />
            </div>
            <div className="form-group">
              <label>仓库地址（GitHub/Gitee） <span style={{ color: 'red' }}>*</span></label>
              <input
                type="url"
                value={openSourceProjectForm.repo_url}
                onChange={(e) => setOpenSourceProjectForm({ ...openSourceProjectForm, repo_url: e.target.value })}
                placeholder="https://github.com/MechaBabyAi/xxx"
              />
            </div>
            <div className="form-group">
              <label>下载/安装地址（可选）</label>
              <input
                type="url"
                value={openSourceProjectForm.download_url}
                onChange={(e) => setOpenSourceProjectForm({ ...openSourceProjectForm, download_url: e.target.value })}
                placeholder="Releases 页面或 pip install 链接"
              />
            </div>
            <div className="form-group">
              <label>类型/分类</label>
              <input
                type="text"
                value={openSourceProjectForm.category}
                onChange={(e) => setOpenSourceProjectForm({ ...openSourceProjectForm, category: e.target.value })}
                placeholder="如：ComfyUI节点、扩展、工具"
              />
            </div>
            <div className="form-group">
              <label>排序（数字越小越靠前）</label>
              <input
                type="number"
                value={openSourceProjectForm.order_index}
                onChange={(e) => setOpenSourceProjectForm({ ...openSourceProjectForm, order_index: parseInt(e.target.value, 10) || 0 })}
              />
            </div>
            <div className="form-group">
              <label>
                <input
                  type="checkbox"
                  checked={openSourceProjectForm.visible}
                  onChange={(e) => setOpenSourceProjectForm({ ...openSourceProjectForm, visible: e.target.checked })}
                  style={{ marginRight: '0.5rem' }}
                />
                显示
              </label>
            </div>
            <div className="form-actions">
              <button onClick={handleSaveOpenSourceProject} className="submit-btn">保存</button>
              <button
                onClick={() => {
                  setShowAddOpenSourceProject(false);
                  setEditingOpenSourceProject(null);
                  setOpenSourceProjectForm({ name: '', description: '', repo_url: '', download_url: '', category: '', order_index: 0, visible: true });
                }}
                className="cancel-btn"
              >
                取消
              </button>
            </div>
          </div>
        )}

        <div className="items-list">
          {openSourceProjects.length === 0 ? (
            <div className="empty-tip">暂无开源项目，点击「添加开源项目」创建</div>
          ) : (
            openSourceProjects.map((project) => (
              <div key={project.id} id={`open-source-project-${project.id}`}>
                <div className="item-card">
                  <div className="item-info" style={{ flex: 1 }}>
                    <h4>{project.name}</h4>
                    <p style={{ color: 'var(--text-secondary)', marginTop: '0.25rem' }}>
                      {project.category && <span style={{ color: 'var(--primary-color)', marginRight: '0.5rem' }}>{`[${project.category}]`}</span>}
                      {project.repo_url}
                    </p>
                  </div>
                  <div className="item-actions">
                    <button onClick={() => startEditOpenSourceProject(project)} className="edit-btn">编辑</button>
                    <button onClick={() => handleDeleteOpenSourceProject(project.id)} className="delete-btn">删除</button>
                  </div>
                </div>
                {editingOpenSourceProject === project.id && (
                  <div className="form-card" style={{ marginTop: '1rem', marginLeft: '2rem' }}>
                    <div className="form-group">
                      <label>名称</label>
                      <input
                        type="text"
                        value={openSourceProjectForm.name}
                        onChange={(e) => setOpenSourceProjectForm({ ...openSourceProjectForm, name: e.target.value })}
                      />
                    </div>
                    <div className="form-group">
                      <label>简介</label>
                      <textarea
                        value={openSourceProjectForm.description}
                        onChange={(e) => setOpenSourceProjectForm({ ...openSourceProjectForm, description: e.target.value })}
                        rows={2}
                      />
                    </div>
                    <div className="form-group">
                      <label>仓库地址</label>
                      <input
                        type="url"
                        value={openSourceProjectForm.repo_url}
                        onChange={(e) => setOpenSourceProjectForm({ ...openSourceProjectForm, repo_url: e.target.value })}
                      />
                    </div>
                    <div className="form-group">
                      <label>下载/安装地址</label>
                      <input
                        type="url"
                        value={openSourceProjectForm.download_url}
                        onChange={(e) => setOpenSourceProjectForm({ ...openSourceProjectForm, download_url: e.target.value })}
                      />
                    </div>
                    <div className="form-group">
                      <label>类型/分类</label>
                      <input
                        type="text"
                        value={openSourceProjectForm.category}
                        onChange={(e) => setOpenSourceProjectForm({ ...openSourceProjectForm, category: e.target.value })}
                      />
                    </div>
                    <div className="form-group">
                      <label>排序</label>
                      <input
                        type="number"
                        value={openSourceProjectForm.order_index}
                        onChange={(e) => setOpenSourceProjectForm({ ...openSourceProjectForm, order_index: parseInt(e.target.value, 10) || 0 })}
                      />
                    </div>
                    <div className="form-group">
                      <label>
                        <input
                          type="checkbox"
                          checked={openSourceProjectForm.visible}
                          onChange={(e) => setOpenSourceProjectForm({ ...openSourceProjectForm, visible: e.target.checked })}
                          style={{ marginRight: '0.5rem' }}
                        />
                        显示
                      </label>
                    </div>
                    <div className="form-actions">
                      <button onClick={handleSaveOpenSourceProject} className="submit-btn">保存</button>
                      <button
                        onClick={() => {
                          setEditingOpenSourceProject(null);
                          setOpenSourceProjectForm({ name: '', description: '', repo_url: '', download_url: '', category: '', order_index: 0, visible: true });
                        }}
                        className="cancel-btn"
                      >
                        取消
                      </button>
                    </div>
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      </div>
      )}

      {activeMenu === 'qqGroups' && (
      <div className="admin-section">
        <h2>QQ群管理</h2>
        <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem', flexWrap: 'wrap' }}>
          <button
            onClick={() => {
              setEditingQqGroup(null);
              setShowAddQqGroup(true);
              setQqGroupForm({ name: '', qq_number: '', order_index: 0 });
            }}
            className="add-btn"
          >
            添加QQ群
          </button>
        </div>

        {showAddQqGroup && (
          <div className="form-card">
            <div className="form-group">
              <label>群名称</label>
              <input
                type="text"
                value={qqGroupForm.name}
                onChange={(e) => setQqGroupForm({ ...qqGroupForm, name: e.target.value })}
                placeholder="请输入QQ群名称"
              />
            </div>
            <div className="form-group">
              <label>群号</label>
              <input
                type="text"
                value={qqGroupForm.qq_number}
                onChange={(e) => setQqGroupForm({ ...qqGroupForm, qq_number: e.target.value })}
                placeholder="请输入QQ群号"
              />
            </div>
            <div className="form-group">
              <label>排序（数字越小越靠前）</label>
              <input
                type="number"
                value={qqGroupForm.order_index}
                onChange={(e) => setQqGroupForm({ ...qqGroupForm, order_index: parseInt(e.target.value, 10) || 0 })}
              />
            </div>
            <div className="form-actions">
              <button onClick={handleSaveQqGroup} className="submit-btn">保存</button>
              <button
                onClick={() => {
                  setShowAddQqGroup(false);
                  setEditingQqGroup(null);
                  setQqGroupForm({ name: '', qq_number: '', order_index: 0 });
                }}
                className="cancel-btn"
              >
                取消
              </button>
            </div>
          </div>
        )}

        <div className="items-list">
          {qqGroups.length === 0 ? (
            <div className="empty-tip">尚未添加任何QQ群，点击上方“添加QQ群”进行配置。</div>
          ) : (
            qqGroups.map((group) => (
              <div key={group.id} id={`qq-group-${group.id}`}>
                <div className="item-card">
                  <div className="item-info" style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                    <h4>{group.name}</h4>
                    <p>
                      群号: {group.qq_number}
                      <span style={{ marginLeft: '1rem', color: '#00d4ff' }}>
                        排序: {group.order_index ?? 0}
                      </span>
                    </p>
                  </div>
                  <div className="item-actions">
                    <button onClick={() => startEditQqGroup(group)} className="edit-btn">编辑</button>
                    <button onClick={() => handleDeleteQqGroup(group.id)} className="delete-btn">删除</button>
                  </div>
                </div>
                {editingQqGroup === group.id && (
                  <div className="form-card" style={{ marginTop: '1rem', marginLeft: '2rem' }}>
                    <div className="form-group">
                      <label>群名称</label>
                      <input
                        type="text"
                        value={qqGroupForm.name}
                        onChange={(e) => setQqGroupForm({ ...qqGroupForm, name: e.target.value })}
                        placeholder="请输入QQ群名称"
                      />
                    </div>
                    <div className="form-group">
                      <label>群号</label>
                      <input
                        type="text"
                        value={qqGroupForm.qq_number}
                        onChange={(e) => setQqGroupForm({ ...qqGroupForm, qq_number: e.target.value })}
                        placeholder="请输入QQ群号"
                      />
                    </div>
                    <div className="form-group">
                      <label>排序（数字越小越靠前）</label>
                      <input
                        type="number"
                        value={qqGroupForm.order_index}
                        onChange={(e) => setQqGroupForm({ ...qqGroupForm, order_index: parseInt(e.target.value, 10) || 0 })}
                      />
                    </div>
                    <div className="form-actions">
                      <button onClick={handleSaveQqGroup} className="submit-btn">保存</button>
                      <button
                        onClick={() => {
                          setEditingQqGroup(null);
                          setQqGroupForm({ name: '', qq_number: '', order_index: 0 });
                        }}
                        className="cancel-btn"
                      >
                        取消
                      </button>
                    </div>
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      </div>
      )}

      {activeMenu === 'videos' && (
      <div className="admin-section">
        <h2>视频管理</h2>
        <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem', flexWrap: 'wrap' }}>
          <button 
            onClick={() => { 
              setEditingVideo(null);
              setShowAddVideo(true);
              setVideoForm({ title: '', url: '', bvid: '', description: '', thumbnail: '', embed_code: '', category: '', order_index: 0 }); 
            }}
            className="add-btn"
          >
            添加视频
          </button>
          {selectedVideos.length > 0 && (
            <button 
              onClick={() => {
                setBatchTable('videos');
                setShowBatchModal(true);
              }}
              className="add-btn"
              style={{ background: '#52c41a' }}
            >
              批量设置分类 ({selectedVideos.length})
            </button>
          )}
        </div>
        
        {showAddVideo && (
          <div className="form-card">
            <div className="form-group">
              <label>标题</label>
              <input
                type="text"
                value={videoForm.title}
                onChange={(e) => setVideoForm({ ...videoForm, title: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label>视频链接（B站视频URL，会自动提取BV号）</label>
              <input
                type="text"
                value={videoForm.url}
                onChange={(e) => handleVideoUrlChange(e.target.value)}
                placeholder="https://www.bilibili.com/video/BV1GE1jB5EJ2"
              />
              {videoForm.bvid && (
                <small style={{ color: '#00d4ff', display: 'block', marginTop: '0.5rem' }}>
                  已提取BV号: {videoForm.bvid}
                </small>
              )}
            </div>
            <div className="form-group">
              <label>描述</label>
              <textarea
                value={videoForm.description}
                onChange={(e) => setVideoForm({ ...videoForm, description: e.target.value })}
                rows={3}
              />
            </div>
            <div className="form-group">
              <label>嵌入代码（推荐，从B站视频页面分享→嵌入代码获取）</label>
              <textarea
                value={videoForm.embed_code}
                onChange={(e) => setVideoForm({ ...videoForm, embed_code: e.target.value })}
                placeholder='<iframe src="//player.bilibili.com/player.html?bvid=BV1GE1jB5EJ2&page=1" ...></iframe>'
                rows={4}
              />
              <small style={{ color: '#b0b8d1', display: 'block', marginTop: '0.5rem' }}>
                提示：在B站视频页面点击"分享"→"嵌入代码"，复制完整代码粘贴到这里
              </small>
            </div>
            <div className="form-group">
              <label>缩略图URL（可选）</label>
              <input
                type="text"
                value={videoForm.thumbnail}
                onChange={(e) => setVideoForm({ ...videoForm, thumbnail: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label>分类（如：一键整合包、comfyui工作流、comfyui工具集等）<span style={{ color: 'red' }}>*</span></label>
              <input
                type="text"
                value={videoForm.category}
                onChange={(e) => setVideoForm({ ...videoForm, category: e.target.value })}
                placeholder="请输入分类名称（必填）"
                required
              />
            </div>
            <div className="form-group">
              <label>排序（数字越小越靠前）</label>
              <input
                type="number"
                value={videoForm.order_index}
                onChange={(e) => setVideoForm({ ...videoForm, order_index: parseInt(e.target.value) || 0 })}
              />
            </div>
            <div className="form-actions">
              <button onClick={handleSaveVideo} className="submit-btn">保存</button>
              <button onClick={() => { 
                setEditingVideo(null); 
                setShowAddVideo(false);
                setVideoForm({ title: '', url: '', bvid: '', description: '', thumbnail: '', embed_code: '', category: '', order_index: 0 }); 
              }} className="cancel-btn">取消</button>
            </div>
          </div>
        )}

        <div className="items-list">
          {videos.map((video) => (
            <div key={video.id} id={`video-${video.id}`}>
              <div className="item-card">
                <div className="item-info" style={{ display: 'flex', alignItems: 'center', gap: '1rem', flex: 1 }}>
                  <input
                    type="checkbox"
                    checked={selectedVideos.includes(video.id)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedVideos([...selectedVideos, video.id]);
                      } else {
                        setSelectedVideos(selectedVideos.filter(id => id !== video.id));
                      }
                    }}
                    onClick={(e) => e.stopPropagation()}
                  />
                  <div style={{ flex: 1 }}>
                    <h4>{video.title}</h4>
                    <p>BV号: {video.bvid} {video.category && <span style={{ color: '#00d4ff', marginLeft: '1rem' }}>分类: {video.category}</span>}</p>
                  </div>
                </div>
                <div className="item-actions">
                  <button
                    onClick={async () => {
                      const url = `${window.location.origin}/tutorials?video=${video.id}`;
                      try {
                        await navigator.clipboard.writeText(url);
                        showToast('已复制视频教程链接');
                      } catch {
                        showToast('复制失败，请重试');
                      }
                    }}
                    className="edit-btn"
                    style={{ marginRight: '0.5rem' }}
                    title="视频教程页单独链接"
                  >
                    复制教程链接
                  </button>
                  <button
                    onClick={async () => {
                      const url = `${window.location.origin}/downloads?video_id=${video.id}`;
                      try {
                        await navigator.clipboard.writeText(url);
                        showToast('已复制资源页链接');
                      } catch {
                        showToast('复制失败，请重试');
                      }
                    }}
                    className="edit-btn"
                    style={{ marginRight: '0.5rem' }}
                    title="展示该视频关联的全部资源（资源中心+AI创作助手）"
                  >
                    复制资源页链接
                  </button>
                  <button onClick={() => startEditVideo(video)} className="edit-btn">编辑</button>
                  <button onClick={() => handleDeleteVideo(video.id)} className="delete-btn">删除</button>
                </div>
              </div>
              {editingVideo === video.id && (
                <div className="form-card" style={{ marginTop: '1rem', marginLeft: '2rem' }}>
                  <div className="form-group">
                    <label>标题</label>
                    <input
                      type="text"
                      value={videoForm.title}
                      onChange={(e) => setVideoForm({ ...videoForm, title: e.target.value })}
                    />
                  </div>
                  <div className="form-group">
                    <label>视频链接（B站视频URL，会自动提取BV号）</label>
                    <input
                      type="text"
                      value={videoForm.url}
                      onChange={(e) => handleVideoUrlChange(e.target.value)}
                      placeholder="https://www.bilibili.com/video/BV1GE1jB5EJ2"
                    />
                    {videoForm.bvid && (
                      <small style={{ color: '#00d4ff', display: 'block', marginTop: '0.5rem' }}>
                        已提取BV号: {videoForm.bvid}
                      </small>
                    )}
                  </div>
                  <div className="form-group">
                    <label>描述</label>
                    <textarea
                      value={videoForm.description}
                      onChange={(e) => setVideoForm({ ...videoForm, description: e.target.value })}
                      rows={3}
                    />
                  </div>
                  <div className="form-group">
                    <label>嵌入代码（推荐，从B站视频页面分享→嵌入代码获取）</label>
                    <textarea
                      value={videoForm.embed_code}
                      onChange={(e) => setVideoForm({ ...videoForm, embed_code: e.target.value })}
                      placeholder='<iframe src="//player.bilibili.com/player.html?bvid=BV1GE1jB5EJ2&page=1" ...></iframe>'
                      rows={4}
                    />
                    <small style={{ color: '#b0b8d1', display: 'block', marginTop: '0.5rem' }}>
                      提示：在B站视频页面点击"分享"→"嵌入代码"，复制完整代码粘贴到这里
                    </small>
                  </div>
                  <div className="form-group">
                    <label>缩略图URL（可选）</label>
                    <input
                      type="text"
                      value={videoForm.thumbnail}
                      onChange={(e) => setVideoForm({ ...videoForm, thumbnail: e.target.value })}
                    />
                  </div>
                  <div className="form-group">
                    <label>分类（如：一键整合包、comfyui工作流、comfyui工具集等）<span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      value={videoForm.category}
                      onChange={(e) => setVideoForm({ ...videoForm, category: e.target.value })}
                      placeholder="请输入分类名称（必填）"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>排序（数字越小越靠前）</label>
                    <input
                      type="number"
                      value={videoForm.order_index}
                      onChange={(e) => setVideoForm({ ...videoForm, order_index: parseInt(e.target.value) || 0 })}
                    />
                  </div>
                  <div className="form-actions">
                    <button onClick={handleSaveVideo} className="submit-btn">保存</button>
                    <button onClick={() => { 
                      setEditingVideo(null); 
                      setVideoForm({ title: '', url: '', bvid: '', description: '', thumbnail: '', embed_code: '', category: '', order_index: 0 }); 
                    }} className="cancel-btn">取消</button>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      )}

      {activeMenu === 'downloads' && (
      <div className="admin-section">
        <h2>下载链接管理</h2>
        <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem', flexWrap: 'wrap' }}>
          <button 
            onClick={() => { 
              setEditingDownload(null);
              setShowAddDownload(true);
              setDownloadForm({ title: '', platform: '百度网盘', url: '', description: '', video_ids: [], category: '', official_url: '', order_index: 0, visible: true }); 
            }}
            className="add-btn"
          >
            添加下载链接
          </button>
          {selectedDownloads.length > 0 && (
            <button 
              onClick={() => {
                setBatchTable('downloads');
                setShowBatchModal(true);
              }}
              className="add-btn"
              style={{ background: '#52c41a' }}
            >
              批量设置分类 ({selectedDownloads.length})
            </button>
          )}
        </div>
        
        {showAddDownload && (
          <div className="form-card">
            <div className="form-group">
              <label>标题</label>
              <input
                type="text"
                value={downloadForm.title}
                onChange={(e) => setDownloadForm({ ...downloadForm, title: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label>平台</label>
              <select
                value={downloadForm.platform}
                onChange={(e) => setDownloadForm({ ...downloadForm, platform: e.target.value })}
              >
                <option value="百度网盘">百度网盘</option>
                <option value="夸克网盘">夸克网盘</option>
                <option value="阿里云盘">阿里云盘</option>
                <option value="迅雷云盘">迅雷云盘</option>
                <option value="123云盘">123云盘</option>
                <option value="直链地址">直链地址</option>
                <option value="抱抱脸">抱抱脸</option>
                <option value="C站">C站</option>
                <option value="其他">其他</option>
              </select>
            </div>
            <div className="form-group">
              <label>关联视频（可选，可多选，该资源可以关联多个视频）</label>
              <div style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid var(--border-color)', borderRadius: '8px', padding: '0.5rem' }}>
                {videos.map(video => (
                  <label key={video.id} style={{ display: 'block', padding: '0.5rem', cursor: 'pointer' }}>
                    <input
                      type="checkbox"
                      checked={downloadForm.video_ids.includes(video.id)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setDownloadForm({ ...downloadForm, video_ids: [...downloadForm.video_ids, video.id] });
                        } else {
                          setDownloadForm({ ...downloadForm, video_ids: downloadForm.video_ids.filter(id => id !== video.id) });
                        }
                      }}
                      style={{ marginRight: '0.5rem' }}
                    />
                    {video.title}
                  </label>
                ))}
              </div>
              {downloadForm.video_ids.length === 0 && (
                <small style={{ color: '#b0b8d1', display: 'block', marginTop: '0.5rem' }}>
                  提示：不选择任何视频表示这是通用资源
                </small>
              )}
            </div>
            <div className="form-group">
              <label>链接URL（网盘链接）</label>
              <input
                type="text"
                value={downloadForm.url}
                onChange={(e) => setDownloadForm({ ...downloadForm, url: e.target.value })}
                placeholder="https://..."
              />
            </div>
            <div className="form-group">
              <label>官方下载链接（可选，软件官网或官方下载页面的直链地址）</label>
              <input
                type="text"
                value={downloadForm.official_url}
                onChange={(e) => setDownloadForm({ ...downloadForm, official_url: e.target.value })}
                placeholder="https://example.com/download"
              />
              <small style={{ color: '#b0b8d1', display: 'block', marginTop: '0.5rem' }}>
                提示：这是从软件官方直接下载的链接，或跳转到官网下载页面的地址
              </small>
            </div>
            <div className="form-group">
              <label>描述</label>
              <textarea
                value={downloadForm.description}
                onChange={(e) => setDownloadForm({ ...downloadForm, description: e.target.value })}
                rows={3}
              />
            </div>
            <div className="form-group">
              <label>分类（如：一键整合包、comfyui工作流、comfyui工具集等）<span style={{ color: 'red' }}>*</span></label>
              <input
                type="text"
                value={downloadForm.category}
                onChange={(e) => setDownloadForm({ ...downloadForm, category: e.target.value })}
                placeholder="请输入分类名称（必填）"
                required
              />
            </div>
            <div className="form-group">
              <label>排序（数字越小越靠前）</label>
              <input
                type="number"
                value={downloadForm.order_index}
                onChange={(e) => setDownloadForm({ ...downloadForm, order_index: parseInt(e.target.value) || 0 })}
              />
            </div>
            <div className="form-group">
              <label>
                <input
                  type="checkbox"
                  checked={downloadForm.visible}
                  onChange={(e) => setDownloadForm({ ...downloadForm, visible: e.target.checked })}
                  style={{ marginRight: '0.5rem' }}
                />
                显示此链接（取消勾选将隐藏，前端用户看不到）
              </label>
            </div>
            <div className="form-actions">
              <button onClick={handleSaveDownload} className="submit-btn">保存</button>
              <button onClick={() => { 
                setEditingDownload(null); 
                setShowAddDownload(false);
                setDownloadForm({ title: '', platform: '百度网盘', url: '', description: '', video_id: '', category: '', order_index: 0, visible: true }); 
              }} className="cancel-btn">取消</button>
            </div>
          </div>
        )}

        <div className="items-list">
          {downloads.map((download) => {
            const isVisible = download.visible === 1 || download.visible === true;
            const videoIds = download.video_ids || (download.video_id ? [download.video_id] : []);
            return (
              <div key={download.id} id={`download-${download.id}`}>
                <div className="item-card" style={{ opacity: isVisible ? 1 : 0.6 }}>
                  <div className="item-info" style={{ display: 'flex', alignItems: 'center', gap: '1rem', flex: 1 }}>
                    <input
                      type="checkbox"
                      checked={selectedDownloads.includes(download.id)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedDownloads([...selectedDownloads, download.id]);
                        } else {
                          setSelectedDownloads(selectedDownloads.filter(id => id !== download.id));
                        }
                      }}
                      onClick={(e) => e.stopPropagation()}
                    />
                    <div style={{ flex: 1 }}>
                      <h4>
                        {download.title}
                        {!isVisible && <span style={{ marginLeft: '0.5rem', color: '#ff6b9d', fontSize: '0.85rem' }}>(已隐藏)</span>}
                      </h4>
                      <p>{download.platform} - {download.url}</p>
                      {download.category && (
                        <p style={{ color: '#00d4ff', fontSize: '0.9rem', marginTop: '0.5rem' }}>
                          分类: {download.category}
                        </p>
                      )}
                      {videoIds.length > 0 && (
                        <p style={{ color: '#00d4ff', fontSize: '0.9rem', marginTop: '0.5rem' }}>
                          关联视频: {videoIds.map(vid => videos.find(v => v.id === vid)?.title || '未知').join(', ')}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="item-actions">
                    <button 
                      onClick={() => handleToggleVisibility(download)} 
                      className={isVisible ? "toggle-btn" : "toggle-btn"}
                      style={{ 
                        background: isVisible ? '#52c41a' : '#999',
                        color: 'white',
                        marginRight: '0.5rem'
                      }}
                    >
                      {isVisible ? '隐藏' : '显示'}
                    </button>
                    <button
                      onClick={async () => {
                        const link = `/downloads?highlight=${download.id}`;
                        try {
                          await navigator.clipboard.writeText(link);
                          showToast('已复制链接');
                        } catch {
                          showToast('复制失败，请重试');
                        }
                      }}
                      className="edit-btn"
                      style={{ marginRight: '0.5rem' }}
                    >
                      复制链接
                    </button>
                    <button onClick={() => startEditDownload(download)} className="edit-btn">编辑</button>
                    <button onClick={() => handleDeleteDownload(download.id)} className="delete-btn">删除</button>
                  </div>
                </div>
                {editingDownload === download.id && (
                  <div className="form-card" style={{ marginTop: '1rem', marginLeft: '2rem' }}>
                    <div className="form-group">
                      <label>标题</label>
                      <input
                        type="text"
                        value={downloadForm.title}
                        onChange={(e) => setDownloadForm({ ...downloadForm, title: e.target.value })}
                      />
                    </div>
                    <div className="form-group">
                      <label>平台</label>
                      <select
                        value={downloadForm.platform}
                        onChange={(e) => setDownloadForm({ ...downloadForm, platform: e.target.value })}
                      >
                        <option value="百度网盘">百度网盘</option>
                        <option value="夸克网盘">夸克网盘</option>
                        <option value="阿里云盘">阿里云盘</option>
                        <option value="迅雷云盘">迅雷云盘</option>
                        <option value="123云盘">123云盘</option>
                        <option value="直链地址">直链地址</option>
                        <option value="其他">其他</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label>关联视频（可选，可多选，该资源可以关联多个视频）</label>
                      <div style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid var(--border-color)', borderRadius: '8px', padding: '0.5rem' }}>
                        {videos.map(video => (
                          <label key={video.id} style={{ display: 'block', padding: '0.5rem', cursor: 'pointer' }}>
                            <input
                              type="checkbox"
                              checked={downloadForm.video_ids.includes(video.id)}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setDownloadForm({ ...downloadForm, video_ids: [...downloadForm.video_ids, video.id] });
                                } else {
                                  setDownloadForm({ ...downloadForm, video_ids: downloadForm.video_ids.filter(id => id !== video.id) });
                                }
                              }}
                              style={{ marginRight: '0.5rem' }}
                            />
                            {video.title}
                          </label>
                        ))}
                      </div>
                      {downloadForm.video_ids.length === 0 && (
                        <small style={{ color: '#b0b8d1', display: 'block', marginTop: '0.5rem' }}>
                          提示：不选择任何视频表示这是通用资源
                        </small>
                      )}
                    </div>
                    <div className="form-group">
                      <label>链接URL（网盘链接）</label>
                      <input
                        type="text"
                        value={downloadForm.url}
                        onChange={(e) => setDownloadForm({ ...downloadForm, url: e.target.value })}
                        placeholder="https://..."
                      />
                    </div>
                    <div className="form-group">
                      <label>官方下载链接（可选，软件官网或官方下载页面的直链地址）</label>
                      <input
                        type="text"
                        value={downloadForm.official_url}
                        onChange={(e) => setDownloadForm({ ...downloadForm, official_url: e.target.value })}
                        placeholder="https://example.com/download"
                      />
                      <small style={{ color: '#b0b8d1', display: 'block', marginTop: '0.5rem' }}>
                        提示：这是从软件官方直接下载的链接，或跳转到官网下载页面的地址
                      </small>
                    </div>
                    <div className="form-group">
                      <label>描述</label>
                      <textarea
                        value={downloadForm.description}
                        onChange={(e) => setDownloadForm({ ...downloadForm, description: e.target.value })}
                        rows={3}
                      />
                    </div>
                    <div className="form-group">
                      <label>分类（如：一键整合包、comfyui工作流、comfyui工具集等）<span style={{ color: 'red' }}>*</span></label>
                      <input
                        type="text"
                        value={downloadForm.category}
                        onChange={(e) => setDownloadForm({ ...downloadForm, category: e.target.value })}
                        placeholder="请输入分类名称（必填）"
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>排序（数字越小越靠前）</label>
                      <input
                        type="number"
                        value={downloadForm.order_index}
                        onChange={(e) => setDownloadForm({ ...downloadForm, order_index: parseInt(e.target.value) || 0 })}
                      />
                    </div>
                    <div className="form-group">
                      <label>
                        <input
                          type="checkbox"
                          checked={downloadForm.visible}
                          onChange={(e) => setDownloadForm({ ...downloadForm, visible: e.target.checked })}
                          style={{ marginRight: '0.5rem' }}
                        />
                        显示此链接（取消勾选将隐藏，前端用户看不到）
                      </label>
                    </div>
                    <div className="form-actions">
                      <button onClick={handleSaveDownload} className="submit-btn">保存</button>
                      <button onClick={() => { 
                        setEditingDownload(null); 
                        setDownloadForm({ title: '', platform: '百度网盘', url: '', description: '', video_ids: [], category: '', official_url: '', order_index: 0, visible: true }); 
                      }} className="cancel-btn">取消</button>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
      )}

      {activeMenu === 'aiLauncher' && (
      <div className="admin-section">
        <h2>AI创作助手资源管理</h2>
        <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem', flexWrap: 'wrap' }}>
          <button
            onClick={() => {
              setEditingAiLauncherResource(null);
              setShowAddAiLauncherResource(true);
              setAiLauncherForm({ title: '', platform: '魔搭社区', url: '', description: '', video_ids: [], category: '', official_url: '', order_index: 0, visible: true });
            }}
            className="add-btn"
          >
            添加AI创作助手资源
          </button>
          {selectedAiLauncherResources.length > 0 && (
            <button
              onClick={() => {
                setBatchTable('ai_launcher_resources');
                setShowBatchModal(true);
              }}
              className="add-btn"
              style={{ background: '#52c41a' }}
            >
              批量设置分类 ({selectedAiLauncherResources.length})
            </button>
          )}
        </div>

        {showAddAiLauncherResource && (
          <div className="form-card">
            <div className="form-group">
              <label>标题</label>
              <input
                type="text"
                value={aiLauncherForm.title}
                onChange={(e) => setAiLauncherForm({ ...aiLauncherForm, title: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label>平台</label>
              <select
                value={aiLauncherForm.platform}
                onChange={(e) => setAiLauncherForm({ ...aiLauncherForm, platform: e.target.value })}
              >
                <option value="魔搭社区">魔搭社区</option>
                <option value="百度网盘">百度网盘</option>
                <option value="夸克网盘">夸克网盘</option>
                <option value="阿里云盘">阿里云盘</option>
                <option value="迅雷云盘">迅雷云盘</option>
                <option value="123云盘">123云盘</option>
                <option value="直链地址">直链地址</option>
                <option value="抱抱脸">抱抱脸</option>
                <option value="C站">C站</option>
                <option value="其他">其他</option>
              </select>
            </div>
            <div className="form-group">
              <label>关联视频（可选，可多选）</label>
              <div style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid var(--border-color)', borderRadius: '8px', padding: '0.5rem' }}>
                {videos.map(video => (
                  <label key={video.id} style={{ display: 'block', padding: '0.5rem', cursor: 'pointer' }}>
                    <input
                      type="checkbox"
                      checked={aiLauncherForm.video_ids.includes(video.id)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setAiLauncherForm({ ...aiLauncherForm, video_ids: [...aiLauncherForm.video_ids, video.id] });
                        } else {
                          setAiLauncherForm({ ...aiLauncherForm, video_ids: aiLauncherForm.video_ids.filter(id => id !== video.id) });
                        }
                      }}
                      style={{ marginRight: '0.5rem' }}
                    />
                    {video.title}
                  </label>
                ))}
              </div>
              {aiLauncherForm.video_ids.length === 0 && (
                <small style={{ color: '#b0b8d1', display: 'block', marginTop: '0.5rem' }}>
                  提示：不选择任何视频表示这是通用资源
                </small>
              )}
            </div>
            <div className="form-group">
              <label>链接URL</label>
              <input
                type="text"
                value={aiLauncherForm.url}
                onChange={(e) => setAiLauncherForm({ ...aiLauncherForm, url: e.target.value })}
                placeholder="https://..."
              />
            </div>
            <div className="form-group">
              <label>官方下载链接（可选）</label>
              <input
                type="text"
                value={aiLauncherForm.official_url}
                onChange={(e) => setAiLauncherForm({ ...aiLauncherForm, official_url: e.target.value })}
                placeholder="https://example.com/download"
              />
            </div>
            <div className="form-group">
              <label>描述</label>
              <textarea
                value={aiLauncherForm.description}
                onChange={(e) => setAiLauncherForm({ ...aiLauncherForm, description: e.target.value })}
                rows={3}
              />
            </div>
            <div className="form-group">
              <label>分类<span style={{ color: 'red' }}>*</span></label>
              <input
                type="text"
                value={aiLauncherForm.category}
                onChange={(e) => setAiLauncherForm({ ...aiLauncherForm, category: e.target.value })}
                placeholder="请输入分类名称（必填）"
                required
              />
            </div>
            <div className="form-group">
              <label>排序（数字越小越靠前）</label>
              <input
                type="number"
                value={aiLauncherForm.order_index}
                onChange={(e) => setAiLauncherForm({ ...aiLauncherForm, order_index: parseInt(e.target.value) || 0 })}
              />
            </div>
            <div className="form-group">
              <label>
                <input
                  type="checkbox"
                  checked={aiLauncherForm.visible}
                  onChange={(e) => setAiLauncherForm({ ...aiLauncherForm, visible: e.target.checked })}
                  style={{ marginRight: '0.5rem' }}
                />
                显示此资源
              </label>
            </div>
            <div className="form-actions">
              <button onClick={handleSaveAiLauncherResource} className="submit-btn">保存</button>
              <button
                onClick={() => {
                  setShowAddAiLauncherResource(false);
                  setEditingAiLauncherResource(null);
                  setAiLauncherForm({ title: '', platform: '魔搭社区', url: '', description: '', video_ids: [], category: '', official_url: '', order_index: 0, visible: true });
                }}
                className="cancel-btn"
              >
                取消
              </button>
            </div>
          </div>
        )}

        <div className="items-list">
          {aiLauncherResources.length === 0 ? (
            <div className="empty-tip">尚未添加任何AI创作助手资源，点击上方"添加AI创作助手资源"进行配置。</div>
          ) : (
            aiLauncherResources.map((resource) => {
              const isVisible = resource.visible === 1 || resource.visible === true;
              const videoIds = resource.video_ids || (resource.video_id ? [resource.video_id] : []);
              return (
                <div key={resource.id} id={`ai-launcher-resource-${resource.id}`}>
                  <div className="item-card" style={{ opacity: isVisible ? 1 : 0.6 }}>
                    <div className="item-info" style={{ display: 'flex', alignItems: 'center', gap: '1rem', flex: 1 }}>
                      <input
                        type="checkbox"
                        checked={selectedAiLauncherResources.includes(resource.id)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedAiLauncherResources([...selectedAiLauncherResources, resource.id]);
                          } else {
                            setSelectedAiLauncherResources(selectedAiLauncherResources.filter(id => id !== resource.id));
                          }
                        }}
                        onClick={(e) => e.stopPropagation()}
                      />
                      <div style={{ flex: 1 }}>
                        <h4>
                          {resource.title}
                          {!isVisible && <span style={{ marginLeft: '0.5rem', color: '#ff6b9d', fontSize: '0.85rem' }}>(已隐藏)</span>}
                        </h4>
                        <p>{resource.platform} - {resource.url}</p>
                        {resource.category && (
                          <p style={{ color: '#00d4ff', fontSize: '0.9rem', marginTop: '0.5rem' }}>
                            分类: {resource.category}
                          </p>
                        )}
                        {videoIds.length > 0 && (
                          <p style={{ color: '#00d4ff', fontSize: '0.9rem', marginTop: '0.5rem' }}>
                            关联视频: {videoIds.map(vid => videos.find(v => v.id === vid)?.title || '未知').join(', ')}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="item-actions">
                      <button
                        onClick={() => handleToggleAiLauncherVisibility(resource)}
                        className="toggle-btn"
                        style={{
                          background: isVisible ? '#52c41a' : '#999',
                          color: 'white',
                          marginRight: '0.5rem'
                        }}
                      >
                        {isVisible ? '隐藏' : '显示'}
                      </button>
                      <button
                        onClick={async () => {
                          const link = `/ai-launcher?highlight=${resource.id}`;
                          try {
                            await navigator.clipboard.writeText(link);
                            showToast('已复制链接');
                          } catch {
                            showToast('复制失败，请重试');
                          }
                        }}
                        className="edit-btn"
                        style={{ marginRight: '0.5rem' }}
                      >
                        复制链接
                      </button>
                      <button onClick={() => startEditAiLauncherResource(resource)} className="edit-btn">编辑</button>
                      <button onClick={() => handleDeleteAiLauncherResource(resource.id)} className="delete-btn">删除</button>
                    </div>
                  </div>
                  {editingAiLauncherResource === resource.id && (
                    <div className="form-card" style={{ marginTop: '1rem', marginLeft: '2rem' }}>
                      <div className="form-group">
                        <label>标题</label>
                        <input
                          type="text"
                          value={aiLauncherForm.title}
                          onChange={(e) => setAiLauncherForm({ ...aiLauncherForm, title: e.target.value })}
                        />
                      </div>
                      <div className="form-group">
                        <label>平台</label>
                        <select
                          value={aiLauncherForm.platform}
                          onChange={(e) => setAiLauncherForm({ ...aiLauncherForm, platform: e.target.value })}
                        >
                <option value="魔搭社区">魔搭社区</option>
                <option value="百度网盘">百度网盘</option>
                <option value="夸克网盘">夸克网盘</option>
                <option value="阿里云盘">阿里云盘</option>
                <option value="迅雷云盘">迅雷云盘</option>
                <option value="123云盘">123云盘</option>
                <option value="直链地址">直链地址</option>
                <option value="抱抱脸">抱抱脸</option>
                <option value="C站">C站</option>
                <option value="其他">其他</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label>关联视频（可选）</label>
                        <div style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid var(--border-color)', borderRadius: '8px', padding: '0.5rem' }}>
                          {videos.map(video => (
                            <label key={video.id} style={{ display: 'block', padding: '0.5rem', cursor: 'pointer' }}>
                              <input
                                type="checkbox"
                                checked={aiLauncherForm.video_ids.includes(video.id)}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setAiLauncherForm({ ...aiLauncherForm, video_ids: [...aiLauncherForm.video_ids, video.id] });
                                  } else {
                                    setAiLauncherForm({ ...aiLauncherForm, video_ids: aiLauncherForm.video_ids.filter(id => id !== video.id) });
                                  }
                                }}
                                style={{ marginRight: '0.5rem' }}
                              />
                              {video.title}
                            </label>
                          ))}
                        </div>
                      </div>
                      <div className="form-group">
                        <label>链接URL</label>
                        <input
                          type="text"
                          value={aiLauncherForm.url}
                          onChange={(e) => setAiLauncherForm({ ...aiLauncherForm, url: e.target.value })}
                          placeholder="https://..."
                        />
                      </div>
                      <div className="form-group">
                        <label>官方下载链接（可选）</label>
                        <input
                          type="text"
                          value={aiLauncherForm.official_url}
                          onChange={(e) => setAiLauncherForm({ ...aiLauncherForm, official_url: e.target.value })}
                          placeholder="https://example.com/download"
                        />
                      </div>
                      <div className="form-group">
                        <label>描述</label>
                        <textarea
                          value={aiLauncherForm.description}
                          onChange={(e) => setAiLauncherForm({ ...aiLauncherForm, description: e.target.value })}
                          rows={3}
                        />
                      </div>
                      <div className="form-group">
                        <label>分类<span style={{ color: 'red' }}>*</span></label>
                        <input
                          type="text"
                          value={aiLauncherForm.category}
                          onChange={(e) => setAiLauncherForm({ ...aiLauncherForm, category: e.target.value })}
                          placeholder="请输入分类名称（必填）"
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label>排序（数字越小越靠前）</label>
                        <input
                          type="number"
                          value={aiLauncherForm.order_index}
                          onChange={(e) => setAiLauncherForm({ ...aiLauncherForm, order_index: parseInt(e.target.value) || 0 })}
                        />
                      </div>
                      <div className="form-group">
                        <label>
                          <input
                            type="checkbox"
                            checked={aiLauncherForm.visible}
                            onChange={(e) => setAiLauncherForm({ ...aiLauncherForm, visible: e.target.checked })}
                            style={{ marginRight: '0.5rem' }}
                          />
                          显示此资源
                        </label>
                      </div>
                      <div className="form-actions">
                        <button onClick={handleSaveAiLauncherResource} className="submit-btn">保存</button>
                        <button
                          onClick={() => {
                            setEditingAiLauncherResource(null);
                            setAiLauncherForm({ title: '', platform: '魔搭社区', url: '', description: '', video_ids: [], category: '', official_url: '', order_index: 0, visible: true });
                          }}
                          className="cancel-btn"
                        >
                          取消
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              );
            })
          )}
        </div>
      </div>
      )}
        </main>
      </div>

      {toast.show && (
        <div className="admin-toast">{toast.message}</div>
      )}
    </div>
  );
};

export default Admin;

